import SoonPage from "../SoonPage";

const TayaAcademyPage = () => {
  return <SoonPage selected={"academy"} />;
};

export default TayaAcademyPage;
